export default "__VITE_ASSET__5208afce__"